// extracted by mini-css-extract-plugin
module.exports = {"screenshots":"ScreenshotsApplicationDetailsPageSection_screenshots__vwB7y"};